/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import Layout from '../../../../common/components/layout/Layout';
import Header from '../../../../common/components/layout/Header';
import ListDefy from '../../../../common/components/sections/ListDefy';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../../../common/loading/Loading';
import { attributesBySport } from '../../../../common/data/attributes';
import { getDefyBysportPaginated, resetStateDefy } from '../../../../modules/sport/actions/reducerListDefy';
import { format as formatFns } from 'date-fns';
import { weeklyList } from '../../../../common/data/weeklyList';
import FilterDefy from '../../../../common/components/sections/FilterDefy';
import { getIdSports } from '../../../../common/data/sports';
import Breadcrumb from '../../../../common/components/sections/Breadcrumb';
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const Clubs = (): JSX.Element => {
    const attribute = attributesBySport('defy');
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const query = useQuery();
    const week = query.get('week');
    const region = query.get('region');
    const commune = query.get('commune');
    const limit = query.get('limit');
    const page = query.get('page');
    const onlyAvailable = query.get('onlyAvailable');
    const teamIdRankingFilter = query.get('teamIdRankingFilter');
    const teamNameRankingFilter = query.get('teamNameRankingFilter');
    const teamLogoRankingFilter = query.get('teamLogoRankingFilter');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const attributeUrl = pathname.length > 1 ? pathname[2] : 'arrienda';
    const router = useHistory();

    const [filter, setFilter] = useState<any>({
        week: week,
        region: region,
        commune: commune,
        limit: limit,
        page: page,
        sport: sport,
        onlyAvailable: onlyAvailable,
        teamIdRankingFilter: teamIdRankingFilter,
        teamNameRankingFilter: teamNameRankingFilter,
        teamLogoRankingFilter: teamLogoRankingFilter,
    });
    const breads = [
        {
            key: 'sport',
            name: 'Desafiar | Buscar',
            url: `/desafiar`,
            add: true,
        },
        {
            key: 'challenge',
            name: 'Desafío',
            url: `/desafiar/equipos/filter${location.search}`,
            add: true,
        },
    ];
    /*List Defys */
    const selectListDefys = (state: any) => state.listDefys;
    const defys = useSelector(selectListDefys);
    const startHour = formatFns(new Date(), "H':'m");

    useEffect(() => {
        dispatch(resetStateDefy());
    }, []);

    useEffect(() => {
        if (sport && region) {
            filter.week;
            let lWeek = null;
            if (filter.week !== '' && filter.week !== 'null') {
                lWeek = weeklyList().find((item) => item.id === filter.week);
            }
            const query = {
                sport: filter.sport,
                week: filter.week || '',
                startDate:
                    filter.week !== '' && filter.week !== 'null'
                        ? filter.startDate
                            ? filter.startDate
                            : lWeek?.start || ''
                        : '',
                endDate:
                    filter.week !== '' && filter.week !== 'null'
                        ? filter.endDate
                            ? filter.endDate
                            : lWeek?.end || ''
                        : '',
                region: filter.region,
                commune: filter.commune,
                startHour: startHour,
                limit: filter.limit,
                page: filter.page,
                onlyAvailable: filter.onlyAvailable,
                teamIdRankingFilter: filter.teamIdRankingFilter,
                teamNameRankingFilter: filter.teamNameRankingFilter,
                teamLogoRankingFilter: filter.teamLogoRankingFilter,
            };

            dispatch(getDefyBysportPaginated(query));
        }
    }, [filter]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handlerPositions = (e: any) => {
        e.preventDefault();
        const path = `/${sport}/${attributeUrl}/equipos/posiciones/filter`;
        const search = `?region=${filter?.region}&commune=${filter?.commune}&sportId=${getIdSports(
            sport,
        )}&teamIdRankingFilter=${filter.teamIdRankingFilter}&teamNameRankingFilter=${
            filter.teamNameRankingFilter
        }&teamLogoRankingFilter=${filter.teamLogoRankingFilter}`;
        router.push({
            pathname: path,
            search: search,
        });
    };

    return (
        <Layout navProps={{ title: 'Desafíar | Supermatch', description: 'Desafíar Supermatch' }}>
            <div className="bg-gradient-to-r from-[#93607b] via-[#67637f] to-[#387082]">
                {breads && breads.length > 0 && (
                    <Breadcrumb
                        contents={breads}
                        color={`bg-opacity-75 bg-gradient-to-r from-[#93607b] via-[#67637f] to-[#387082] ${attribute?.color.bg}`}
                        classItems="text-white font-light"
                        classActive="text-white"
                    />
                )}
                <Header />
                <div
                    key={'profile-form'}
                    className={`pt-24 pb-5 min-h-layout container mx-auto sm:w-[70%] md:w-[70%] lg:w-[70%] xl:w-[70%] w-full `}
                >
                    {attribute ? (
                        <FilterDefy
                            filter={filter}
                            setFilter={setFilter}
                            dateList={weeklyList()}
                            handlerPositions={handlerPositions}
                        />
                    ) : (
                        ''
                    )}
                    <div className="container-list xl:pt-6 lg:pt-6 pt-12">
                        <h2 className="font-bold text-[22px] text-white text-center italic">ELIGE TU DESAFÍO</h2>
                        {teamNameRankingFilter !== '' ? (
                            <h2 className="font-bold text-[22px] text-white text-center italic">
                                Vs {teamNameRankingFilter}
                            </h2>
                        ) : (
                            <div></div>
                        )}
                        {defys.isLoading ? (
                            <Loading />
                        ) : defys.error && defys.error.code ? (
                            <div className="flex items-center justify-center lg:h-96 mb:h-96 ">
                                <p className="text-2xl text-sm-blue-primary">
                                    El Servicio no está Disponible en estos momentos
                                </p>
                            </div>
                        ) : (
                            <ListDefy
                                filter={filter}
                                setFilter={setFilter}
                                origin={'defy-team'}
                                sport={sport}
                                data={defys.data}
                                attribute={attribute}
                            />
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Clubs;
